import {inject, Injectable} from '@angular/core';
import {filter, map, Observable, switchMap} from "rxjs";
import { MapsService } from '../maps.service';
import {MapDirectionsService} from "@angular/google-maps";

@Injectable({
  providedIn: 'root',
})
export class MapLatLangToDirectionResultService {
  mapDirectionsService = inject(MapDirectionsService);
  mapLatLangToDirectionResult =  (source: Observable<google.maps.LatLng[]>) => {
    return source.pipe(
      map((locations) => MapsService.getDirectionsRequestFromLocationsArray(locations)),
      filter((request): request is google.maps.DirectionsRequest => !!request),
      switchMap((request) => {
        return this.mapDirectionsService.route(request).pipe(
          map((response) => response.result),
          filter((result): result is google.maps.DirectionsResult => !!result)
        );
      })
    );
  }
}
